var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImaglog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2033_17697",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 75,
    height: 75
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2033_17697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9531 45.5469H57.5L47.5781 32.1875L39.5312 42.7344L34.2188 35.9375L26.9531 45.5469ZM20.3125 59.375C19.0625 59.375 17.9688 58.9063 17.0312 57.9688C16.0938 57.0313 15.625 55.9375 15.625 54.6875V10.9375C15.625 9.6875 16.0938 8.59375 17.0312 7.65625C17.9688 6.71875 19.0625 6.25 20.3125 6.25H64.0625C65.3125 6.25 66.4063 6.71875 67.3438 7.65625C68.2813 8.59375 68.75 9.6875 68.75 10.9375V54.6875C68.75 55.9375 68.2813 57.0313 67.3438 57.9688C66.4063 58.9063 65.3125 59.375 64.0625 59.375H20.3125ZM10.9375 68.75C9.6875 68.75 8.59375 68.2813 7.65625 67.3438C6.71875 66.4063 6.25 65.3125 6.25 64.0625V15.625H10.9375V64.0625H59.375V68.75H10.9375Z",
    fill: "#B00041"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImaglog);
export default __webpack_public_path__ + "static/media/imaglog.0e1ee40d6cc47b600aae372300364590.svg";
export { ForwardRef as ReactComponent };